import React from 'react';
import { FormProvider as RHFFormProvider, useForm } from 'react-hook-form';
import type { SubmitHandler, FieldValues } from 'react-hook-form';
import { zodResolver } from '@hookform/resolvers/zod';
import { z } from 'zod';

export interface FormProviderProps<T extends FieldValues = FieldValues> {
  schema: z.ZodSchema<T>;
  defaultValues?: T;
  onSubmit: SubmitHandler<T>;
  children: React.ReactNode;
  className?: string;
  id?: string;
}

export function FormProvider<T extends FieldValues = FieldValues>({
  schema,
  defaultValues,
  onSubmit,
  children,
  className,
  id,
}: FormProviderProps<T>) {
  const methods = useForm<T>({
    resolver: zodResolver(schema as any),
    defaultValues: defaultValues as any,
    mode: 'onTouched',
  });

  const handleFormSubmit = methods.handleSubmit(onSubmit);

  return (
    <form
      className={className}
      onSubmit={handleFormSubmit}
      noValidate
      id={id}
    >
      <RHFFormProvider {...methods}>
        {children}
      </RHFFormProvider>
    </form>
  );
}